import auth from '@middlewares/Auth';

export default [
  {
    url: '/groups',
    page: 'groups/Index',
    name: 'groups',
    meta: {
      label: 'Groups',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourism-operator', 'tourist'],
      },
    },
    group: [
      {
        url: 'create',
        page: 'groups/Create',
        name: 'new-group',
      },
      {
        url: ':id',
        page: 'groups/Create',
        name: 'edit-group',
      },
      {
        url: ':id/members',
        page: 'groups/Members',
        name: 'group-members',
      },
    ],
  },
];
